(function($, $doc) {
	(function($, settings) {
		var instance = 0, instances = [], Class;

		Class = function($shell, settings) {
			var my, cls;

			cls = {
				adjust: function() {
					return my.adjust.apply($this, arguments);
				}
			};

			my = {
				enable: function() {
					if ($shell.data("wsroundabout-active")) {
						return $shell;
					}

					settings = $.extend({
						'classes': {
							'nav': 'nav',
							'next': 'next',
							'prev': 'prev',
							'active': 'active',
							'outer': 'roundabout-outer',
							'inner': 'roundabout-inner',
							'canvas': 'canvas',
							'label': 'label'
						},
						'selectors': {
							'nav': '.nav',
							'item_label': '.label'
						},
						'labels': {
							'prev': '',
							'next': ''
						},
						'index': 1,
						'show': 3,
						'increment': 1,
						'label': true
					}, settings || {});

					my.ui = {
						'$inner': $("<div>", {
							'class': settings.classes.inner
						}),
						'$outer': $("<div>", {
							'class': settings.classes.outer
						}),
						'$canvas': $("<div>", {
							'class': settings.classes.canvas
						}).css({
							'overflow': 'hidden'
						}),
						'$items': $shell.find("li"),
						'nav': {
							'$prev': $("<a>", {
								'href': '#',
								'class': settings.classes.nav + ' ' + settings.classes.prev
							}).append(
								$("<span>").text(settings.labels.prev)
							),
							'$next': $("<a>", {
								'href': '#',
								'class': settings.classes.nav + ' ' + settings.classes.next
							}).append(
								$("<span>").text(settings.labels.next)
							)
						},
						'$label': $("<div>", {
							'class': settings.classes.label
						})
					};

					my.status = {
						'index': null,
						'original_length': my.ui.$items.length
					};

					cls.status = my.status;

					// bind events
					my.ui.$outer.on("click", settings.selectors.nav, my.event);

					$shell.data("wsroundabout-active", true);

					my.parse();

					my.select(settings.index, true);
				},

				event: function(event) {
					var $this;

					if (event.type === "click") {
						event.preventDefault();
						$this = $(this);

						if ($this.hasClass(settings.classes.next)) {
							my.adjust(settings.increment, my.status.index, my.select);
						} else if ($this.hasClass(settings.classes.prev)) {
							my.adjust(-settings.increment, my.status.index, my.select);
						}
					}
				},

				parse: function() {
					// prep container
					$shell.before(my.ui.$outer);

					my.ui.$outer.append(
						my.ui.$inner.append(
							my.ui.$canvas.append(
								$shell.css({
									'position': 'relative'
								})
							),
							my.ui.nav.$prev,
							my.ui.nav.$next
						),
						my.ui.$label
					);

					// set width of individual items
					my.status.width = my.ui.$items.eq(0).width();

					// set width of canvas, etc
					my.ui.$canvas.css({
						'width': (my.status.width * settings.show) + 'px'
					});

					my.ui.$inner.css({
						'width': (my.status.width * settings.show) + 'px'
					});

					// prepare LIs within the container
					my.ui.$items
						.slice(0, (settings.show))
						.each(function(index) {
							var $item = $(this).clone(true);
							$shell.append($item);
							my.ui.$items = my.ui.$items.add($item);
						});

					$shell.css({
						'width': (my.status.width * my.ui.$items.length) + 'px'
					});
				},

				adjust: function(adjustment, current_index, after) {
					var index;

					index = current_index + adjustment;

					if (index < 0) {
						index = my.ui.$items.length - 1;
					} else if (index > (my.ui.$items.length - 1)) {
						index = 0;
					}

					if (typeof after === "function") {
						after(index);
					} else {
						return index;
					}
				},

				select: function(index, instant) {
					var $current, offset, show_halved;

					show_halved = Math.floor(settings.show / 2);

					if (index !== my.status.index) {
						// de-select old item
						if (my.status.index !== null) {
							my.ui.$items.eq(my.status.index).removeClass(settings.classes.active);
						}

						if (index === ((my.ui.$items.length) - show_halved) &&
							index > my.status.index) {
							// index is at the halfway point of the end repetition - loop back to beginning
							index = (my.ui.$items.length - 1) - my.status.original_length;

							$shell.css({
								'left': 0
							});
						} else if (index < show_halved && index < my.status.index) {
							// index is at the halfway point of the beginning - loop back to the end
							index = ((my.ui.$items.length - 1) - show_halved);

							$shell.css({
								'left': -(my.status.width * (my.ui.$items.length - settings.show)) + 'px'
							});

							index -= 1;
						}

						// set current item
						$current = my.ui.$items.eq(index);

						// If left/previous plate is empty plate, disable prev button
						if ( $current.prev().hasClass('empty') ) {
							my.ui.nav.$prev.addClass('hide');
						} else {
							my.ui.nav.$prev.removeClass('hide');
						}

						// If right/next plate is empty plate, disable next button
						if ( $current.next().hasClass('empty') ) {
							my.ui.nav.$next.addClass('hide');
						} else {
							my.ui.nav.$next.removeClass('hide');
						}

						// set label
						if (settings.label) {
							my.ui.$label.html("").append(
								$current.find(settings.selectors.item_label).clone(true)
							);
						}

						// animate to current item
						$shell.stop().animate({
							'left': -((my.status.width * index) - (my.status.width * show_halved)) + 'px'
						}, 300, 'easeInOutCirc');

						$current.addClass(settings.classes.active);
						my.status.index = index;
					}
				}
			};

			my.enable();

			return cls;
		};

		$.fn.WSRoundabout = function() {
			var a, $this, args;

			args = arguments;

			this.each(function() {
				$this = $(this);

				if ((a = $this.data("wsroundabout-instance")) === undefined) {
					$this.data("wsroundabout-instance", instance);
					a = instance;
					instance = instance + 1;
				}

				if (typeof args[0] === "string") {
					if (instances[a] && instances[a][args[0]]) {
						instances[a][args[0]].apply($this, Array.prototype.slice.call(args, [1]));
					} else {
						throw new Error("Instance must be created before methods are used");
					}
				} else {
					instances.push(new Class($this, args[0]));
				}
			});

			return this;
		};
	}($));
}(window.jQuery, window.jQuery(document.body)));
